(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name flightWatch.controller:RotationSummaryCtrl
	 *
	 * @description
	 *
	 */
	angular.module('flightWatch').controller('RotationSummaryCtrl',
			RotationSummaryCtrl);

	function RotationSummaryCtrl($uibModalInstance, modalParams, FlightWatch,
			MessageService, EventManagerService, CommonMasterData) {
		var vm = this;
		vm.ctrlName = 'RotationSummaryCtrl';

		vm.model = {
			searchCriteria : {
				fromDate : "",
				toDate : "",
				fullSchedule : null
			},
			masterList : {
				fullScheduleList : []
			},
			scheduleSummaryList : [],
			dateRangeForTitle : "",
			fromDateAfterToDate : false,
			fromDateNotInFullSchedPeriod : false,
			toDateNotInFullSchedPeriod :false,
			selectedRow : -1
		};

		vm.changeField = function(flag) {
			if (flag == 'schedule') {
				if (!!vm.model.searchCriteria.fullSchedule
						&& !!vm.model.searchCriteria.fullSchedule.scheduleName) {
					// auto Set From date and ToDate
					vm.model.searchCriteria.fromDate = angular
							.copy(vm.model.searchCriteria.fullSchedule.startDate);
					vm.model.searchCriteria.toDate = angular
							.copy(vm.model.searchCriteria.fullSchedule.endDate);
				}
			} else if(flag == 'fromDate' && !!vm.model.searchCriteria.fromDate){
				if(!vm.model.searchCriteria.fullSchedule && !vm.model.searchCriteria.toDate){
					vm.model.searchCriteria.toDate = getMonthEndDate(vm.model.searchCriteria.fromDate);
				}
			}
			setDateValidationFlags();
			setDateRangeTitle();
		};

		function getMonthEndDate(date) {
        	if (!!date) {
        		return moment(date, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
        	}
        	return null;
        };

		function setDateValidationFlags() {
			if (!isDateFormatInvalid(vm.model.searchCriteria.fromDate)
					&& !isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.fromDateAfterToDate = isDay1BeforeDay2(
						vm.model.searchCriteria.toDate,
						vm.model.searchCriteria.fromDate);
				if (!vm.model.fromDateAfterToDate) {
					vm.model.fromDateNotInFullSchedPeriod = !isDateInFullSchedPeriod(vm.model.searchCriteria.fromDate);
					if(!vm.model.fromDateNotInFullSchedPeriod){
						vm.model.toDateNotInFullSchedPeriod = !isDateInFullSchedPeriod(vm.model.searchCriteria.toDate);
					} else {
						vm.model.toDateNotInFullSchedPeriod = false;
					}
				} else {
					vm.model.fromDateNotInFullSchedPeriod = false;
					vm.model.toDateNotInFullSchedPeriod = false;
				}
			} else {
				vm.model.fromDateAfterToDate = false;
				vm.model.fromDateNotInFullSchedPeriod = false;
				vm.model.toDateNotInFullSchedPeriod = false;
			}
		}

		function isDateInFullSchedPeriod(date) {
			if (!!vm.model.searchCriteria.fullSchedule
					&& !!vm.model.searchCriteria.fullSchedule.scheduleName
					&& !isDateFormatInvalid(date)
					&& (isDay1BeforeDay2(date, vm.model.searchCriteria.fullSchedule.startDate)
							|| isDay1BeforeDay2(vm.model.searchCriteria.fullSchedule.endDate, date))) {
				return false;
			}
			return true;
		}

		function setDateRangeTitle() {
			if (!!vm.model.searchCriteria.fromDate && !isDateFormatInvalid(vm.model.searchCriteria.fromDate)
					&& !!vm.model.searchCriteria.toDate && !isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				var fromDateStr = moment(vm.model.searchCriteria.fromDate,
						'DD/MM/YYYY').format("Do MMM YYYY");
				var toDateStr = moment(vm.model.searchCriteria.toDate,
						'DD/MM/YYYY').format("Do MMM YYYY");
				vm.model.dateRangeForTitle = " - " + fromDateStr + " to "
						+ toDateStr;
			} else {
				vm.model.dateRangeForTitle = "";
			}
		}

		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}
		;
		// check from date and to date
		function isDay1BeforeDay2(day1, day2) {
			return moment(day1, "DD/MM/YYYY").isBefore(
					moment(day2, "DD/MM/YYYY"));
		}
		;
		vm.searchRotationSummary = function(searchCrieteria) {
			setDateRangeTitle();
			vm.rotationSummaryForm.$submitted = true;
			setDateValidationFlags();
			if (isSearchParamValid()) {
				var request = getSearchRotationSummaryRequest(searchCrieteria);
				FlightWatch.searchRotationSummary(request, function(response) {
					vm.model.scheduleSummaryList = response;
				}, function(error) {
				//	MessageService.error(error);
          MessageService.error("Date Format is incorrect. Please enter in  (DD/MM/YYYY).");
				});
			}
		}

		function getSearchRotationSummaryRequest(searchCrieteria) {
			var req = {};
			req.fromDate = searchCrieteria.fromDate;
			req.toDate = searchCrieteria.toDate;
			if (!!searchCrieteria.fullSchedule
					&& !!searchCrieteria.fullSchedule.scheduleName) {
				req.scheduleType = searchCrieteria.fullSchedule.scheduleType;
				req.scheduleYear = searchCrieteria.fullSchedule.scheduleYear;
			}
			return req;
		}

		function isSearchParamValid() {
			if (vm.rotationSummaryForm.$valid && !vm.model.fromDateAfterToDate
					&& !vm.model.fromDateNotInFullSchedPeriod && !vm.model.toDateNotInFullSchedPeriod) {
				return true;
			}
			return false;
		}

		function getFullScheduleListForRotationSummary(){
        	CommonMasterData.getFullScheduleListForRotationSummary(
                    function (fullScheduleList) {
                        vm.model.masterList.fullScheduleList = fullScheduleList;
                    },
                    function () {
                        console.log('Full Schedule List retrieval error');
                    }
                );
        }

		getFullScheduleListForRotationSummary();

		vm.onCloseClick = function() {
			$uibModalInstance.close(modalParams.close);
		};

	}
}());
